import { find } from "lodash"
import React, { useState } from "react"

import MoneyInput from "../../inputs/MoneyInput"
import DateInput from "../../inputs/DateInput"
import BackArrow from "../../BackArrow"
import { format as formatDate } from "date-fns"

import { postRequest } from "../../../helpers/api"

const initialValues = {
  provider_name: "",
  current_value: "",
  start_date: "",
  monthly_payment: "",
}

const BankLoan = ({ onBack, onSuccess, hideTitle }) => {
  const [isSaving, setIsSaving] = useState(false)
  const [errors, setErrors] = useState({})
  const [form, setValues] = useState({ ...initialValues })

  return (
    <>
      {!hideTitle &&
        <>
          <BackArrow onClick={onBack} />
          <h1 className="page-title">Add bank loan</h1>
        </>
      }

      <form
        onSubmit={async e => {
          e.preventDefault()

          if (isSaving) return

          setIsSaving(true)

          console.log("Submit form", form)

          const resp = await postRequest(`/api/assets`, { asset_category: "bank_loan", ...form })
          const json = await resp.json()

          if (resp.status === 201) {
            console.log("success", json)
            onSuccess(json.data)
          } else {
            console.log("failed resp", resp)
            setErrors(json.validation_errors)
          }

          setIsSaving(false)
        }}
      >
        <div className="form-field -maxlength">
          <label htmlFor="provider_name">Bank name</label>
          <input type="text" id="provider_name" placeholder="e.g. Santander" value={form.provider_name} onChange={e => setValues({ ...form, provider_name: e.target.value })} />
          {find(errors, row => row.field === "provider_name") && <span className="hint -error">{find(errors, row => row.field === "provider_name").errors.join(", ")}</span>}
        </div>

        <div className="form-field -maxlength">
          <label htmlFor="current_value">Loan amount</label>
          <MoneyInput id="current_value" defaultValue={form.current_value} onChange={current_value => setValues({ ...form, current_value })} />
          {find(errors, row => row.field === "current_value") && <span className="hint -error">{find(errors, row => row.field === "current_value").errors.join(", ")}</span>}
        </div>

        <div className="form-field -maxlength">
          <label htmlFor="monthly_payment">Monthly Payment</label>
          <MoneyInput id="monthly_payment" defaultValue={form.monthly_payment} onChange={monthly_payment => setValues({ ...form, monthly_payment })} />
          {find(errors, row => row.field === "monthly_payment") && <span className="hint -error">{find(errors, row => row.field === "monthly_payment").errors.join(", ")}</span>}
        </div>

        <div className="form-field -maxlength">
          <label htmlFor="start_date">Start date</label>
          <DateInput value={form.start_date || ""} onDayChange={date => setValues({ ...form, start_date: formatDate(date, "YYYY-MM-DD") })} />
          {find(errors, row => row.field === "start_date") && <span className="hint -error">{find(errors, row => row.field === "start_date").errors.join(", ")}</span>}
        </div>        

        <div className="flex items-center">
          <button disabled={isSaving} type="submit" className="button -primary mr3">
            {isSaving ? 'Saving...' : 'Add loan'}
          </button>
          <button disabled={isSaving} onClick={onBack} className="button">Cancel</button>
        </div>
      </form>
    </>
  )
}

export default BankLoan
